/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ul[_ngcontent-%COMP%]{margin:0}ul.dashed[_ngcontent-%COMP%]{list-style-type:none}ul.dashed[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{text-indent:-5px}ul.dashed[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:before{content:\"- \";text-indent:-5px}.button-back[_ngcontent-%COMP%]{width:200px}"];
export { styles as styles };
